import keyMirror from '../common/keyMirror';
export default keyMirror({
  LOAD_SUCCESS: null,
  ADD_START: null,
  ADD_CANCEL: null,
  ADD_SUBMIT: null,
  ADD_SUCCESS: null,
  DELETE_SUBMIT: null,
  DELETE_SUCCESS: null,
  RESEND_VERIFY_SUBMIT: null,
  RESEND_VERIFY_SUCCESS: null,
  SET_PRIMARY_SUBMIT: null,
  SET_PRIMARY_SUCCESS: null,
  FAIL: null,
  LOAD_FAIL: null,
  CLEAR_FAIL: null
}, 'LOGIN_EMAILS_');